"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsIE = exports.HtmlUtil = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.HtmlUtil = {
    encodeUri: function (value) {
        value = encodeURIComponent(value);
        return lodash_1.default.replace(value, new RegExp('%', 'g'), '{~}');
    },
};
var IsIE = function () {
    return window.navigator.userAgent.indexOf('Trident') > -1;
};
exports.IsIE = IsIE;
